import React, { FormEvent} from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import {
  arrowForward,
} from 'ionicons/icons';
import { RootState, actions } from '../store';
import {
  IonRefresher, IonRefresherContent, withIonLifeCycle,
  IonInfiniteScroll, IonInfiniteScrollContent, IonIcon,
  IonPage, IonItem, IonCardContent, IonLoading,
  IonCard, IonAlert, IonLabel, IonModal,
  IonBackButton, IonButtons, IonContent, IonButton,
  IonHeader, IonTitle, IonToolbar, IonTextarea,
} from '@ionic/react';
import Answers from '../components/Answers';
import { Token } from '../store/users/types';
import SkeletonLoadingIonList from '../components/SkeletonLoadingIonList';

type Props = RouteComponentProps<{ id: string, tab: string }> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  goBack: () => void
};

type State = {
  showAlert: boolean,
  question: string,
  message: string,
  showModal: boolean,
  selectedQuestion: string,
};

class Questions extends React.Component<Props, State> {
  defaultState: State = {
    showAlert: false,
    question: '',
    message: '',
    showModal: false,
    selectedQuestion: '',
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState
    };
  }

  // async ionViewDidEnter() {
  //   if (this.props.tokens && this.props.tokens.id_token) {
  //     return;
  //   }
  //   const tokens: Token = await localForage.getItem('tokens');
  //   const todayTime = new Date().getTime();
  //   if (tokens && tokens.refresh_token) {
  //     if (!tokens.expired_at || tokens.expired_at < todayTime) {
  //       this.props.refreshTokens(tokens.refresh_token);
  //     } else {
  //       this.props.setTokens(tokens);
  //     }
  //   }
  // }

  componentDidMount() {
    const { match, getQuestions } = this.props;
    const parkCode = match.params.id;
    getQuestions(parkCode);
  }

  doRefresh = (e: CustomEvent) => {
    const { match, getQuestions } = this.props;
    const parkCode = match.params.id;
    getQuestions(parkCode);
    e && (e.target as any).complete();
  }

  loadMoreQuestions = (event: CustomEvent<void>) => {
    const { match, getQuestions, loadedQuestions } = this.props;
    const { nextKey } = loadedQuestions;
    const parkCode = match.params.id;
    getQuestions(parkCode, nextKey);
  }
  handleSubmit = async(e: FormEvent) => {
    e.preventDefault();
    const { tokens, isLoggedIn, match, getQuestions } = this.props;
    const parkCode = match.params.id;
    if (!isLoggedIn) {
      this.setState({
        ...this.state,
        showAlert: true,
        message: 'Please login to add a question.',
      });
      return;
    }
    const { question } = this.state;
    if (question.length < 10) {
      this.setState({
        ...this.state,
        showAlert: true,
        message: 'Your question must be at least 10 characters long.',
      });
      return;
    }
    await this.props.addQuestion(tokens, parkCode, question);
    this.setState ({
      ...this.state,
      question: '',
    });
    setTimeout(async() => {
      await getQuestions(parkCode);
    }, 2000);
  }
  handleChange = (attribute: string, val: any) => {
    const newState  = {[attribute]: val};
    this.setState({
      ...this.state,
      ...newState,
    });
  }
  dismissAlert() {
    this.setState({
      ...this.state,
      showAlert: false,
    });
    this.props.updateApiError('');
  }

  dismissModal = () => {
    this.setState(() => ({
      showModal: false,
    }));
  };

  showAnswers = (question: any) => {
    this.setState({
      ...this.state,
      showModal: true,
      selectedQuestion: question,
    });
  };

  render() {
    const { match, parkMap, loadedQuestions, actionLoading, loading, apiError } = this.props;
    const parkCode = match.params.id;
    const park = parkMap[parkCode] || {};
    const parkName = park.name;
    const hasNoQuestions = !loadedQuestions || !loadedQuestions.questions || loadedQuestions.questions.length === 0;
    return (
      <>
      <IonModal
        isOpen={this.state.showModal}
        onDidDismiss={this.dismissModal}
      >
        <Answers
          goBack={this.dismissModal}
          selectedQuestion={this.state.selectedQuestion}
        />
      </IonModal>
      <IonAlert
        isOpen={!!apiError || this.state.showAlert}
        onDidDismiss={() => this.dismissAlert()}
        header={'Alert'}
        message={apiError || this.state.message}
        buttons={['OK']}
      />
      <IonLoading
        isOpen={actionLoading}
        message={'Please wait...'}
        duration={3000}
      />
      <IonPage className="questions">
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref={`/${match.params.tab}/${match.params.tab}/${parkCode}`} />
            </IonButtons>
            <IonTitle>{parkName} Questions</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonRefresher closeDuration="2000ms" slot="fixed" onIonRefresh={(e: CustomEvent) => this.doRefresh(e)}>
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>
          <IonCard>
            <IonCardContent>
              <form onSubmit={e => this.handleSubmit(e)}>
              <h1>Add your question</h1>
                <IonTextarea
                  disabled={!this.props.isLoggedIn} required
                  value={this.state.question}
                  placeholder={this.props.isLoggedIn ? "Add your question here..." : "You must be logged in to add a question here"}
                  onIonChange={e => this.handleChange('question', e.detail.value!)}/>
                <IonButton disabled={!this.props.isLoggedIn} type="submit" className="ion-float-right" >Add</IonButton>
              </form>
              <br />
              <br />
              <h3>Question(s)</h3>
              <SkeletonLoadingIonList isLoading={loading} />
              {
                hasNoQuestions ?
                <>No questions found. Be the first one to add a question.</>
                :
                loadedQuestions.questions.map((item: any, index: number) => {
                  return (
                    <IonItem onClick={() => this.showAnswers(item)} key={`question-${index}`}>
                      <IonLabel>
                        <p>
                          <b>{index + 1}. {item.question}</b><br />
                          {item.username}&nbsp; {new Date(item.added_on).toLocaleDateString()}
                        </p>
                      </IonLabel>
                      <IonIcon className='arrow-right' icon={arrowForward} />
                    </IonItem>
                  );
                })
              }
              <IonInfiniteScroll disabled={!loadedQuestions.nextKey} threshold="100px" onIonInfinite={this.loadMoreQuestions}>
                <IonInfiniteScrollContent
                  loadingSpinner="bubbles"
                  loadingText="Loading more data..." />
              </IonInfiniteScroll>
            </IonCardContent>
          </IonCard>
        </IonContent>
      </IonPage>
      </>
    );
  }
}

const mapDispatchToProps = {
  refreshTokens: (refresh_token: string) => actions.users.refreshTokens(refresh_token),
  setTokens: (tokens: Token) => actions.users.setTokens(tokens),
  getQuestions: (parkCode: string, nextKey?: string) => actions.questions.getQuestions(parkCode, nextKey),
  addQuestion: (tokens: Token, parkCode: string, question: string) => actions.questions.addQuestion(tokens, parkCode, question),
  updateApiError: (apiError: string) => actions.questions.updateApiError(apiError),
}

const mapStateToProps = (state: RootState) => ({
  tokens: state.users.tokens,
  apiError: state.questions.apiError,
  isLoggedIn: state.users.loggedIn,
  parkMap: state.places.parkMap,
  loadedQuestions: state.questions.loadedQuestions,
  loading: state.questions.loading,
  actionLoading: state.questions.actionLoading,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  )(withIonLifeCycle(Questions));
